module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "skala-form"
    }
  }, [_c('v-card', {
    attrs: {
      "text": ""
    }
  }, [_c('v-list-item', {
    staticClass: "pa-0",
    attrs: {
      "two-line": ""
    }
  }, [_c('v-list-item-content', {
    staticClass: "pa-0"
  }, [_c('v-list-item-title', {
    staticClass: "font-weight-500 darkgrey--text pb-2"
  }, [_vm._v("\n                    Nama Skala\n                ")]), _vm._v(" "), _c('v-text-field', {
    attrs: {
      "placeholder": "Nama Skala",
      "outlined": ""
    },
    model: {
      value: (_vm.data.scale_name),
      callback: function($$v) {
        _vm.$set(_vm.data, "scale_name", $$v)
      },
      expression: "data.scale_name"
    }
  })], 1)], 1), _vm._v(" "), _c('v-list-item', {
    staticClass: "pa-0",
    attrs: {
      "two-line": ""
    }
  }, [_c('v-list-item-content', {
    staticClass: "pa-0"
  }, [_c('v-list-item-title', {
    staticClass: "font-weight-500 darkgrey--text pb-2"
  }, [_vm._v("\n                    Jenjang\n                ")]), _vm._v(" "), _c('div', {
    staticClass: "d-inline mb-5 d-flex",
    staticStyle: {
      "gap": "10px"
    }
  }, [_c('v-checkbox', {
    staticClass: "pa-2 ma-0 d-inline-flex checkbox-selection",
    attrs: {
      "label": "SD",
      "value": "SD",
      "outlined": ""
    },
    model: {
      value: (_vm.data.scale_level),
      callback: function($$v) {
        _vm.$set(_vm.data, "scale_level", $$v)
      },
      expression: "data.scale_level"
    }
  }), _vm._v(" "), _c('v-checkbox', {
    staticClass: "pa-2 ma-0 d-inline-flex checkbox-selection",
    attrs: {
      "label": "SMP",
      "value": "SMP",
      "outlined": ""
    },
    model: {
      value: (_vm.data.scale_level),
      callback: function($$v) {
        _vm.$set(_vm.data, "scale_level", $$v)
      },
      expression: "data.scale_level"
    }
  }), _vm._v(" "), _c('v-checkbox', {
    staticClass: "pa-2 ma-0 d-inline-flex checkbox-selection",
    attrs: {
      "label": "SMA",
      "value": "SMA",
      "outlined": ""
    },
    model: {
      value: (_vm.data.scale_level),
      callback: function($$v) {
        _vm.$set(_vm.data, "scale_level", $$v)
      },
      expression: "data.scale_level"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('v-list-item', {
    staticClass: "pa-0",
    attrs: {
      "two-line": ""
    }
  }, [_c('v-list-item-content', {
    staticClass: "pa-0"
  }, [_c('v-list-item-title', {
    staticClass: "font-weight-500 darkgrey--text pb-2"
  }, [_vm._v("\n                    Jenis\n                ")]), _vm._v(" "), _c('div', {
    staticClass: "d-inline mb-5 d-flex",
    staticStyle: {
      "gap": "10px"
    }
  }, [_c('v-radio-group', {
    staticStyle: {
      "margin-top": "-10px"
    },
    attrs: {
      "row": ""
    },
    model: {
      value: (_vm.data.scale_type),
      callback: function($$v) {
        _vm.$set(_vm.data, "scale_type", $$v)
      },
      expression: "data.scale_type"
    }
  }, [_c('v-radio', {
    staticClass: "radio-selection",
    attrs: {
      "label": "Free",
      "value": "FREE",
      "active-class": "act-radio-btn"
    }
  }), _vm._v(" "), _c('v-radio', {
    staticClass: "radio-selection",
    attrs: {
      "label": "Premium",
      "value": "PREMIUM",
      "active-class": "act-radio-btn"
    }
  })], 1)], 1)], 1)], 1), _vm._v(" "), _c('v-list-item', {
    staticClass: "pa-0",
    attrs: {
      "two-line": ""
    }
  }, [_c('v-list-item-content', {
    staticClass: "pa-0"
  }, [_c('v-list-item-title', {
    staticClass: "font-weight-500 darkgrey--text pb-2"
  }, [_vm._v("\n                    Deskripsi\n                ")]), _vm._v(" "), _c('v-textarea', {
    attrs: {
      "placeholder": "Deskripsi Skala",
      "outlined": ""
    },
    model: {
      value: (_vm.data.scale_description),
      callback: function($$v) {
        _vm.$set(_vm.data, "scale_description", $$v)
      },
      expression: "data.scale_description"
    }
  })], 1)], 1), _vm._v(" "), (_vm.theme_type !== 'tryout') ? _c('v-list-item', {
    staticClass: "pa-0 mb-2",
    attrs: {
      "two-line": ""
    }
  }, [_c('v-list-item-content', {
    staticClass: "pa-0"
  }, [_c('v-list-item-title', {
    staticClass: "font-weight-500 darkgrey--text pb-3"
  }, [_vm._v("\n                    Jenis Respon\n                ")]), _vm._v(" "), _c('v-radio-group', {
    staticStyle: {
      "margin-top": "-10px"
    },
    attrs: {
      "row": ""
    },
    model: {
      value: (_vm.data.type),
      callback: function($$v) {
        _vm.$set(_vm.data, "type", $$v)
      },
      expression: "data.type"
    }
  }, [_c('v-radio', {
    staticClass: "radio-selection",
    attrs: {
      "label": "Likert",
      "value": "likert",
      "active-class": "act-radio-btn"
    }
  }), _vm._v(" "), _c('v-radio', {
    staticClass: "radio-selection",
    attrs: {
      "label": "Multiple Choice",
      "value": "choice",
      "active-class": "act-radio-btn"
    }
  }), _vm._v(" "), _c('v-radio', {
    staticClass: "radio-selection",
    attrs: {
      "label": "Yes or No",
      "value": "yesno",
      "active-class": "act-radio-btn"
    }
  })], 1)], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.data.type === 'likert' && _vm.theme_type !== 'tryout') ? _c('v-list-item', {
    staticClass: "pa-0 mb-2",
    attrs: {
      "two-line": ""
    }
  }, [_c('v-list-item-content', {
    staticClass: "pa-0"
  }, [_c('v-list-item-title', {
    staticClass: "font-weight-500 darkgrey--text pb-3"
  }, [_vm._v("\n                    Jumlah Respon\n                ")]), _vm._v(" "), _c('v-radio-group', {
    staticStyle: {
      "margin-top": "-10px"
    },
    attrs: {
      "row": ""
    },
    model: {
      value: (_vm.data.max_answer),
      callback: function($$v) {
        _vm.$set(_vm.data, "max_answer", $$v)
      },
      expression: "data.max_answer"
    }
  }, [_c('v-radio', {
    staticClass: "radio-selection",
    attrs: {
      "label": "4",
      "value": 4,
      "active-class": "act-radio-btn"
    }
  }), _vm._v(" "), _c('v-radio', {
    staticClass: "radio-selection",
    attrs: {
      "label": "5",
      "value": 5,
      "active-class": "act-radio-btn"
    }
  })], 1)], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.data.type === 'choice' && _vm.theme_type !== 'tryout') ? _c('v-list-item', {
    staticClass: "pa-0 mb-2",
    attrs: {
      "two-line": ""
    }
  }, [_c('v-list-item-content', {
    staticClass: "pa-0"
  }, [_c('v-list-item-title', {
    staticClass: "font-weight-500 darkgrey--text pb-3"
  }, [_vm._v("\n                    Jumlah Respon\n                ")]), _vm._v(" "), _c('v-select', {
    attrs: {
      "outlined": "",
      "items": [3, 4, 5, 6, 7, 8, 9, 10]
    },
    on: {
      "change": function($event) {
        _vm.form_value_answer = []
      }
    },
    model: {
      value: (_vm.jumlah_value),
      callback: function($$v) {
        _vm.jumlah_value = $$v
      },
      expression: "jumlah_value"
    }
  })], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.data.type === 'choice') ? _c('v-list-item', {
    staticClass: "pa-0",
    attrs: {
      "two-line": ""
    }
  }, [_c('v-list-item-content', {
    staticClass: "pa-0"
  }, [_c('v-list-item-title', {
    staticClass: "font-weight-500 darkgrey--text pb-2"
  }, [_vm._v("\n                    Value\n                ")]), _vm._v(" "), _c('div', {
    staticClass: "mt-3 px-1 mb-5"
  }, [_c('v-row', _vm._l((_vm.jumlah_value), function(val, i) {
    return _c('v-col', {
      key: i,
      attrs: {
        "cols": "1"
      }
    }, [_c('v-text-field', {
      staticClass: "font-weight-bold text-center",
      attrs: {
        "maxlength": "1",
        "outlined": ""
      },
      model: {
        value: (_vm.form_value_answer[i]),
        callback: function($$v) {
          _vm.$set(_vm.form_value_answer, i, $$v)
        },
        expression: "form_value_answer[i]"
      }
    })], 1)
  }), 1)], 1)], 1)], 1) : _vm._e(), _vm._v(" "), _c('v-list-item', {
    staticClass: "pa-0",
    attrs: {
      "two-line": ""
    }
  }, [_c('v-list-item-content', {
    staticClass: "pa-0"
  }, [_c('v-list-item-title', {
    staticClass: "font-weight-500 darkgrey--text pb-2"
  }, [_vm._v("\n                    Durasi Pengerjaan Skala\n                ")]), _vm._v(" "), _c('v-text-field', {
    attrs: {
      "type": "text",
      "placeholder": "Durasi (dalam menit)",
      "suffix": "menit",
      "outlined": "",
      "maxlength": "3"
    },
    on: {
      "keypress": function($event) {
        return _vm.handleInputNumber($event)
      }
    },
    model: {
      value: (_vm.data.processing_time),
      callback: function($$v) {
        _vm.$set(_vm.data, "processing_time", $$v)
      },
      expression: "data.processing_time"
    }
  })], 1)], 1), _vm._v(" "), _c('v-list-item', {
    staticClass: "pa-0",
    attrs: {
      "two-line": ""
    }
  }, [_c('v-list-item-content', {
    staticClass: "pa-0"
  }, [_c('v-list-item-title', {
    staticClass: "font-weight-500 darkgrey--text pb-2"
  }, [_vm._v("\n                    Judul Intro\n                ")]), _vm._v(" "), _c('v-text-field', {
    attrs: {
      "placeholder": "Judul Intro",
      "outlined": ""
    },
    model: {
      value: (_vm.data.intro_name),
      callback: function($$v) {
        _vm.$set(_vm.data, "intro_name", $$v)
      },
      expression: "data.intro_name"
    }
  })], 1)], 1), _vm._v(" "), _c('v-list-item', {
    staticClass: "pa-0",
    attrs: {
      "two-line": ""
    }
  }, [_c('v-list-item-content', {
    staticClass: "pa-0"
  }, [_c('v-list-item-title', {
    staticClass: "font-weight-500 darkgrey--text pb-2"
  }, [_vm._v("\n                    Deskripsi Intro\n                ")]), _vm._v(" "), _c('app-editor', {
    attrs: {
      "value": _vm.data.intro_description,
      "hasUpload": false,
      "title": "Deskripsi Intro"
    },
    on: {
      "content-updated": function($event) {
        _vm.data.intro_description = $event
      }
    }
  })], 1)], 1), _vm._v(" "), _c('v-list-item', {
    staticClass: "pa-0",
    attrs: {
      "two-line": ""
    }
  }, [_c('v-list-item-content', {
    staticClass: "pa-0"
  }, [_c('v-list-item-title', {
    staticClass: "font-weight-bold"
  }, [_vm._v("\n                    User Group\n                ")]), _vm._v(" "), _c('v-autocomplete', {
    attrs: {
      "items": _vm.user_groups,
      "item-text": "user_group_name",
      "item-value": "id",
      "placeholder": "-- Pilih user group --",
      "outlined": "",
      "chips": "",
      "multiple": ""
    },
    model: {
      value: (_vm.data.user_group),
      callback: function($$v) {
        _vm.$set(_vm.data, "user_group", $$v)
      },
      expression: "data.user_group"
    }
  })], 1)], 1), _vm._v(" "), _c('v-card-actions', [_c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "depressed": "",
      "text": ""
    },
    on: {
      "click": function($event) {
        return _vm.backToScale()
      }
    }
  }, [_vm._v(" Kembali ")]), _vm._v(" "), _c('v-btn', {
    attrs: {
      "id": "tryout_simpan",
      "color": "blew",
      "loading": _vm.isLoading,
      "depressed": "",
      "dark": ""
    },
    on: {
      "click": function($event) {
        return _vm.submit()
      }
    }
  }, [_vm._v("\n                Selanjutnya\n            ")])], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-40565c25","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/modules/ambis_test/components/SkalaForm.vue
// module id = 1443
// module chunks = 1